import {
  useSchedulerRangeData,
  useSchedulerPropsContext,
} from '../../context/schedulerContext'
import { useWeekContext, WeekProvider } from './WeekProvider'
import { MultiDaySlotLayout } from '../../components/MultiDaySlotLayout/MultiDaySlotLayout'

export function Week() {
  const { visibleRange, visibleDays, cellTimeSlots } =
    useSchedulerRangeData()
  const { events, week } = useSchedulerPropsContext()
  return (
    <WeekProvider
      events={events}
      visibleRange={visibleRange}
      week={week!}
    >
      <WeekLayout
        weekDayDates={visibleDays}
        cellTimeSlots={cellTimeSlots}
      />
    </WeekProvider>
  )
}

export interface WeekLayoutProps {
  weekDayDates: Date[]
  cellTimeSlots: Date[]
}

function WeekLayout({
  weekDayDates,
  cellTimeSlots,
}: WeekLayoutProps) {
  const { singleDayEvents } = useWeekContext()

  return (
    <MultiDaySlotLayout
      weekDayDates={weekDayDates}
      cellTimeSlots={cellTimeSlots}
      events={singleDayEvents}
    />
  )
}
